import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ComingSoon({ moduleName = "This module", eta = "Q3 2026" }) {
  return (
    <div className="px-4 md:px-8 py-24 max-w-2xl mx-auto text-center">
      <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-muted-foreground border border-border rounded-full px-3 py-1.5">
        <Sparkles className="h-3.5 w-3.5 text-primary" /> On the roadmap
      </div>
      <h1 className="font-display text-5xl mt-6 leading-tight">{moduleName} is coming soon.</h1>
      <p className="text-muted-foreground mt-4 max-w-md mx-auto">
        We're crafting this module with the same care as the rest of Kairosa. Expected: <b>{eta}</b>.
        In the meantime, ping Kairosa AI for a preview of what's shipping next.
      </p>
      <Link to="/app" className="inline-block mt-8">
        <Button variant="outline" className="rounded-full gap-2">
          <ArrowLeft className="h-4 w-4" /> Back to dashboard
        </Button>
      </Link>
    </div>
  );
}
